module.exports = __webpack_public_path__ + "img/1495735234.cae52def.jpg";